













import {Vue,Component,Prop, Watch,Mixins} from 'vue-property-decorator';
import BookmarkMixin from './BookmarkMixin';
@Component
export default  class  BooleanBookmark extends Mixins(BookmarkMixin){
    created(){
        this.value = false;
    }
    
}
